/**
 * Адрес, на который человека возвращают после входа.
 *
 * Значение приходит из строки запроса, то есть снаружи, — и потому проверяется.
 * Без проверки ссылка вида /login?next=https://зеркало.example превращает кабинет
 * в открытый перенаправитель: человек видит настоящий адрес planerius, вводит пароль,
 * а дальше его уводят на чужую страницу. Поэтому принимается только путь внутри кабинета.
 */
export function safeNextPath(next: string | undefined, fallback: string): string {
  if (typeof next !== "string") return fallback
  // «//зеркало.example» браузер считает адресом с другим источником, хотя он начинается
  // с косой черты, — поэтому такой случай отсекается отдельно.
  if (!next.startsWith("/") || next.startsWith("//")) return fallback
  return next
}

/**
 * Адрес, которому выбранный салон не нужен.
 *
 * После входа человека без выбранного салона уводят на выбор салона — и возвращают к next
 * только после выбора. Приглашение так ломалось: человек с учёткой, пришедший по ссылке,
 * после входа оказывался на выборе салонов, куда нового салона ещё нет, и приглашение
 * терялось. Принимается оно без салона (сервер: @AllowTenantless), поэтому вход ведёт
 * прямо на него.
 */
export function nextNeedsNoTenant(next: string | undefined): boolean {
  const path = safeNextPath(next, "")
  return path === "/invite" || path.startsWith("/invite?")
}
